// extracted by mini-css-extract-plugin
export default {"subTitle":"tL42nsCaFs2ye8e62ROf","indent":"PBwwlW3qlPAmxFlHqMCd","button":"jEfwnrWHPxzy2uHgjFTw","buttonsContainer":"ypD9mfk6RapKtdakJQyA"};